module.exports = __webpack_public_path__ + "img/jingyingbang-sc.8e9e93c3.png";